import { lazy } from 'react';
import MGMTermsPage from '../pages/terms-page';

const MemberGetMember = lazy(() => import('../pages'));

export const MemberGetMemberRoutes = [
  {
    path: '',
    element: <MemberGetMember />,
  },
  {
    path: 'termos',
    element: <MGMTermsPage />,
  },
];
